import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService, ToastMessage } from '../../../services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.html',
  styleUrl: './toast.css'
})
export class ToastContainer {
  public readonly messages = computed<ToastMessage[]>(() => this.toast.messages());

  constructor(private toast: ToastService) {}

  public dismiss(id: number): void {
    this.toast.remove(id);
  }
}


